import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    isLogin: false,
    avatarimg: '',
  },
  mutations: {
    getuserInfo(state, step) {
      state.username = step.username
      state.avatarimg = step.image
      console.log(step);
    },
    setisLogin(state, step) {
      state.isLogin = step
      console.log(step, 'state.isLogin ');
    },
    emptyUserInfo(state) {
      state.username = ''
      state.avatarimg = ''
    },
  },
  actions: {
    userinfo(context, step) {
      context.commit('getuserInfo', step)
    },
    isclickLogin(context, step) {
      context.commit('setisLogin', step)
    },
    userinfoEmpty(context) {
      context.commit('emptyUserInfo')
    },
  },
  modules: {}
})